import { render } from "./DeleteProviderDialog.vue?vue&type=template&id=b220f7c6&scoped=true"
import script from "./DeleteProviderDialog.vue?vue&type=script&lang=js"
export * from "./DeleteProviderDialog.vue?vue&type=script&lang=js"

import "./DeleteProviderDialog.vue?vue&type=style&index=0&id=b220f7c6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b220f7c6"]])

export default __exports__